import React from 'react'

const NestedAccordionHeader = ({
  onClick,
  title,
  icon,
  variableStyles,
}) => {
  return (
    <div
      style={{
        ...variableStyles,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems:'center',
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      {title} {icon}
    </div>
  );
};

export default NestedAccordionHeader